module.exports = __webpack_public_path__ + "img/jurong-port-logo.1562a1c0.png";